'use client'

import { usePathname } from 'next/navigation'

export default function Footer() {
  const pathname = usePathname()

  return (
    <>
      {pathname === '/' || pathname === '/form' ? (
        <footer id="condition">
          <p className="text-sm text-muted-foreground italic">
          * Offre valable uniquement après validation d'une première commande honorée par le filleul, sous forme d'une remise sur facture fin de mois suivant.
          </p>
        </footer>
      ) : null}
    </>
  )
}
